import { env } from '@/config/env';
const base = env.API_URL || '';

const apiGet = async <T = any>(path: string): Promise<T> => {
  try {
    const res = await fetch(`${base}${path}`, { credentials: 'include' });
    if (!res.ok) throw new Error(`GET ${path} -> ${res.status}`);
    return await res.json() as T;
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error(`Network error: ${error.message}`);
    }
    throw error;
  }
};

const apiPost = async <T = any>(path: string, body?: any): Promise<T> => {
  try {
    const res = await fetch(`${base}${path}`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: body ? JSON.stringify(body) : null,
      credentials: 'include',
    });
    if (res.status === 204) return undefined as unknown as T;
    if (!res.ok) throw new Error(`POST ${path} -> ${res.status}`);
    return await res.json() as T;
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error(`Network error: ${error.message}`);
    }
    throw error;
  }
};

const apiPatch = async <T = any>(path: string, body?: any): Promise<T> => {
  const res = await fetch(`${base}${path}`, {
    method: 'PATCH',
    headers: { 'content-type': 'application/json' },
    body: body ? JSON.stringify(body) : null,
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`PATCH ${path} -> ${res.status}`);
  return res.json() as Promise<T>;
};

const apiDelete = async (path: string): Promise<void> => {
  const res = await fetch(`${base}${path}`, { method: 'DELETE', credentials: 'include' });
  if (!(res.ok || res.status === 204)) throw new Error(`DELETE ${path} -> ${res.status}`);
};

export const apiClient = {
  get: apiGet,
  post: apiPost,
  patch: apiPatch,
  delete: apiDelete,
};

export default apiClient;
